import Vue from 'vue'
import ElementUI from 'element-ui'
import "tailwindcss/tailwind.css"
import locale from 'element-ui/lib/locale/lang/es'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import Vue2Editor from "vue2-editor";
import '../theme/index.css'
import VueI18n from 'vue-i18n';

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(PortalVue)
Vue.use(VueI18n);
Vue.use(VueMeta)
Vue.use(ElementUI,{locale});
Vue.use(Vue2Editor);
InertiaProgress.init()

Vue.directive('uppercase', {
	update (el) {
        if (el && el.value)
		    el.value = el.value.toUpperCase()
	},
})


const i18n = new VueI18n({
    locale: 'es',
  });

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    new Vue({
      metaInfo: {
        titleTemplate: title => (title ? `${title} - Registro de Aspirantes` : 'Registro de Aspirantes'),
      },
      render: h => h(app, props),
      i18n
    }).$mount(el)
  },
})
